'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// check path.params => then make this component redirectable for any other components. 

var RedirectComponent = function (_Component) {
    (0, _inherits3.default)(RedirectComponent, _Component);

    function RedirectComponent() {
        (0, _classCallCheck3.default)(this, RedirectComponent);
        return (0, _possibleConstructorReturn3.default)(this, (RedirectComponent.__proto__ || (0, _getPrototypeOf2.default)(RedirectComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(RedirectComponent, [{
        key: 'render',
        value: function render() {
            // console.log("this.props.params.word");
            // console.log(this.props.params.word);
            return _react2.default.createElement(
                'div',
                null,
                this.props.history.push('/translate/' + this.props.params.word + '/' + this.props.params.langType)
            );
        }
    }]);
    return RedirectComponent;
}(_react.Component);

exports.default = RedirectComponent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/RedirectComponent.js
// module id = 1530
// module chunks = 0